<script setup>
  import TwoPanePage from "@/templates/TwoPanePage.vue";
  import ContactsList from "@/components/Mailing/ContactsList.vue";
  import ContactsEdit from "@/components/Mailing/ContactsEdit.vue";
</script>

<template>
  <TwoPanePage data-cy="survey-mailing-test-page" :span-left="4" :span-right="8">
    <template #left>
      <ContactsList />
    </template>
    <template #right>
      <ContactsEdit />
    </template>
  </TwoPanePage>
</template>
